import Agencies from './components/Agencies';

export default Agencies;
